// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customer-form .el-form-item.customer-name .el-input__inner {\n  width: 49em;\n}", ""]);
// Exports
module.exports = exports;
